module.exports = __webpack_public_path__ + "static/check.3c30357c.svg";